// extracted by mini-css-extract-plugin
export default {"-large":"Jcnqp4PkeVQBW5cN89aE","loadingSkeleton":"VlaJqTgQOuz3lNPbKMyG"};